import { use } from 'i18next';
import { usePolywizzContext } from '../context';

const TotalInfo = () => {
    const { total, t } = usePolywizzContext();

    return (
        <div className="my-2">
            <span>
                {t('Total polywizz clients')}: <b className="text-primary">{total}</b>
            </span>
        </div>
    );
};

export default TotalInfo;
